export const environment = {
    coreBaseUrl: process.env.REACT_APP_CORE_BASE_URL || process.env.CORE_BASE_URL,
    crmsBaseUrl: process.env.REACT_APP_CRMS_BASE_URL || process.env.CRMS_BASE_URL,
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || process.env.GOOGLE_CLIENT_ID,
};